import { Components, Theme } from "@mui/material"

export const MuiToolbar: Components<Theme>["MuiToolbar"] = {
  styleOverrides: {
    root: () => ({
      minHeight: `52px !important`,
    }),
  },
}
